import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512 1024A512 512 0 0115.36 388.267 512 512 0 01950.613 248.32a508.16 508.16 0 0158.027 387.413A512 512 0 01512 1024zm0-998.4a486.4 486.4 0 00-117.76 958.293A486.4 486.4 0 00983.893 629.76 486.4 486.4 0 00629.76 40.107 488.96 488.96 0 00512 25.6zm448.853 526.08a152.747 152.747 0 010 17.92c0 7.253-3.413 11.947-8.106 13.227l-30.294 7.68-46.08 10.666a317.867 317.867 0 01-69.12 8.534 73.813 73.813 0 01-49.066-16.214c-9.814-5.973-14.507-21.333-14.507-45.653v-14.507a247.893 247.893 0 013.84-32 197.973 197.973 0 016.4-29.44c0-5.12 3.84-7.253 5.547-7.253v20.053q0 29.014 14.933 35.84a98.56 98.56 0 0038.4 8.107h23.893a232.96 232.96 0 0033.707-5.973q42.667-8.534 42.667-12.8A284.16 284.16 0 00896 443.733 197.547 197.547 0 00859.307 384L896 314.88a235.947 235.947 0 0142.667 81.067 485.547 485.547 0 0122.186 155.733zM569.6 611.413v-72.96h72.96v72.96zM485.547 714.24a276.053 276.053 0 01-66.56 61.013 384 384 0 01-62.294 35.414 190.72 190.72 0 01-75.52 11.946 139.093 139.093 0 01-128-56.746A228.693 228.693 0 01116.907 640a273.493 273.493 0 0162.72-167.68q19.626-26.88 24.746-32.853l8.96-12.8a64.853 64.853 0 00-25.173-4.267l-17.493 4.267a128 128 0 00-22.614 4.266 145.92 145.92 0 00-18.773 6.827 178.347 178.347 0 00-34.133 29.44 79.36 79.36 0 0111.946-42.667A301.653 301.653 0 01131.413 384a133.973 133.973 0 0124.747-29.867 46.08 46.08 0 0114.507-8.106 105.813 105.813 0 0121.333 0h21.333L256 350.72q26.453 3.413 65.707 7.253l46.506 3.414q42.667 0 85.334-3.84l-46.934 89.173h-17.92a421.12 421.12 0 00-85.333 4.693A145.92 145.92 0 00230.4 486.4a245.76 245.76 0 00-53.333 64 153.173 153.173 0 00-20.054 77.227q0 115.626 177.067 115.626a597.333 597.333 0 00151.467-29.013zM264.96 554.667l78.933 31.573-29.013 64-77.227-32.427z"
});

function SvgDzd(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "DZD_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzd);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'DZDOutlined';

export default KuFoxIcons;
